module.exports = __webpack_public_path__ + "img/no-data.d3a927df.png";